"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("./Button");
var _icons = _interopRequireDefault(require("./constants/icons"));
var _Alert = _interopRequireDefault(require("./styles/Alert"));
var _excluded = ["alerts", "actions", "className", "messageClassName"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AlertMessage = function AlertMessage(_ref) {
  var id = _ref.id,
    type = _ref.type,
    message = _ref.message,
    detail = _ref.detail,
    expandDetail = _ref.expandDetail,
    remove = _ref.remove,
    isExpanded = _ref.isExpanded,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert', ["alert--".concat(type)], _Alert["default"].alert, _Alert["default"][type], className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__content', {
      'alert__content--is-expanded': isExpanded
    }, _Alert["default"].alert__content, isExpanded && _Alert["default"].alert__content_expanded)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__message', _Alert["default"].alert__message)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__icon', _Alert["default"].alert__icon)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__title', _Alert["default"].alert__title)
  }, message), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__actions', _Alert["default"].alert__actions)
  }, detail && !isExpanded && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "alert__expand",
    onClick: function onClick() {
      return expandDetail(id);
    }
  }, "Details"), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: (0, _classnames["default"])('alert__close', _Alert["default"].close),
    "aria-label": "Close Alert",
    icon: _icons["default"].cross,
    onClick: function onClick() {
      return remove(id);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('alert__details', _Alert["default"].alert__details)
  }, detail)));
};
function Alert(_ref2) {
  var alerts = _ref2.alerts,
    actions = _ref2.actions,
    className = _ref2.className,
    messageClassName = _ref2.messageClassName,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    expandedAlerts = _useState2[0],
    setExpanded = _useState2[1];
  if (!alerts.length) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('alert-container', _Alert["default"].container, className)
  }, props), alerts.slice(0, 1).map(function (a) {
    return /*#__PURE__*/_react["default"].createElement(AlertMessage, (0, _extends2["default"])({
      key: a.id
    }, a, {
      className: messageClassName,
      isExpanded: expandedAlerts.includes(a.id),
      expandDetail: function expandDetail(id) {
        return setExpanded(function (p) {
          return [].concat((0, _toConsumableArray2["default"])(p), [id]);
        });
      },
      remove: actions.dismissAlertMessage
    }));
  }));
}
Alert.displayName = 'Alert';
var _default = exports["default"] = Alert;